module.exports = __webpack_public_path__ + "static/media/home2.a2b873e7.gif";